import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiMoreVertical, FiPaperclip, FiMessageCircle } from "react-icons/fi";

export default function ProjectCard({ project, onEdit, onDelete }) {
  return (
    <Card className="project-card mb-3">
      <Card.Body>

        {/* TOP */}
        <div className="d-flex justify-content-between align-items-center">

          <div className="d-flex align-items-center gap-2">

            <span className="tag-box">
              Web Layout
            </span>

            <span
              className={`priority-badge ${
                project.priority === "High"
                  ? "high"
                  : project.priority === "Medium"
                  ? "medium"
                  : "low"
              }`}
            >
              {project.priority}
            </span>

          </div>

          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              size="sm"
              className="border-0 bg-transparent"
            >
              <FiMoreVertical />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={onEdit}>Edit</Dropdown.Item>
              <Dropdown.Item onClick={onDelete}>Delete</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

        </div>

        {/* TITLE */}

        <div className="d-flex align-items-center mt-3">

          <div className="project-icon">
            <img
              src="/assets/img/icons/project.svg"
              alt=""
            />
          </div>

          <h6 className="mb-0 ms-2 fw-semibold">
            {project.title}
            <span className="text-muted ms-2">
              {project.code}
            </span>
          </h6>

        </div>

        {/* DETAILS */}

        <div className="project-stats">

          <div>
            <small>Budget</small>
            <div>${project.budget}</div>
          </div>

          <div>
            <small>Tasks</small>
            <div>{project.tasks}</div>
          </div>

          <div>
            <small>Due on</small>
            <div>{project.due}</div>
          </div>

        </div>

        <hr />

        {/* FOOTER */}

        <div className="d-flex justify-content-between align-items-center">

          {/* avatars */}

          <div className="avatar-group">

            <img src="/assets/img/profiles/avatar-01.jpg" alt="" />
            <img src="/assets/img/profiles/avatar-02.jpg" alt="" />
            <img src="/assets/img/profiles/avatar-03.jpg" alt="" />
            <img src="/assets/img/profiles/avatar-04.jpg" alt="" />

            <span className="avatar-more">+1</span>

          </div>

          {/* icons */}

          <div className="card-icons">

            <span>
              <FiMessageCircle /> 14
            </span>

            <span>
              <FiPaperclip /> 14
            </span>

          </div>

        </div>

      </Card.Body>

      {/* INTERNAL CSS */}

      <style>{`

      .project-card{
        border-radius:10px;
        border:1px solid #e6e6e6;
        box-shadow:0 2px 4px rgba(0,0,0,0.05);
      }

      .tag-box{
        font-size:12px;
        border:1px solid #000;
        padding:4px 10px;
        border-radius:6px;
      }

      .priority-badge{
        font-size:12px;
        padding:4px 10px;
        border-radius:6px;
        color:#fff;
      }

      .priority-badge.low{
        background:#22c55e;
      }

      .priority-badge.medium{
        background:#f59e0b;
      }

      .priority-badge.high{
        background:#8b5cf6;
      }

      .project-icon{
        width:28px;
        height:28px;
        background:#facc15;
        border-radius:50%;
        display:flex;
        align-items:center;
        justify-content:center;
      }

      .project-icon img{
        width:14px;
      }

      .project-stats{
        display:flex;
        justify-content:space-between;
        margin-top:12px;
      }

      .project-stats small{
        color:#888;
        font-size:12px;
      }

      .avatar-group{
        display:flex;
        align-items:center;
      }

      .avatar-group img{
        width:28px;
        height:28px;
        border-radius:50%;
        border:2px solid #fff;
        margin-left:-8px;
      }

      .avatar-more{
        width:28px;
        height:28px;
        border-radius:50%;
        background:#f97316;
        color:white;
        display:flex;
        align-items:center;
        justify-content:center;
        font-size:12px;
        margin-left:-8px;
      }

      .card-icons{
        display:flex;
        gap:15px;
        color:#555;
        font-size:14px;
      }

      .card-icons span{
        display:flex;
        align-items:center;
        gap:4px;
      }

      `}</style>
    </Card>
  );
}